import { render } from "./popup-confirm.vue?vue&type=template&id=b70d5e14&scoped=true"
import script from "./popup-confirm.vue?vue&type=script&lang=js"
export * from "./popup-confirm.vue?vue&type=script&lang=js"

import "./popup-confirm.vue?vue&type=style&index=0&id=b70d5e14&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b70d5e14"]])

export default __exports__